// Auth0 configuration for React frontend
const authorizationParams = {
  // Use window.location.origin for dynamic callback URL
  // Make sure this URL is added to "Allowed Callback URLs" in your Auth0 application settings
  redirect_uri: window.location.origin,
  scope: 'openid profile email'
};

// Only add audience if it's configured (optional for basic auth)
if (process.env.REACT_APP_AUTH0_AUDIENCE && 
    process.env.REACT_APP_AUTH0_AUDIENCE !== 'https://your-api-identifier') {
  authorizationParams.audience = process.env.REACT_APP_AUTH0_AUDIENCE;
}

export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'your-domain.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'your-client-id',
  authorizationParams
}; 